import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { LlScrollpaneService } from '../ll-scrollpane.service';
import { LlPermissionsService } from '../ll-permissions.service';
import { LlInfoBuildService } from '../ll-info-build.service';

@Component({
  selector: 'll-build-form-holder',
  templateUrl: './ll-build-form-holder.component.html',
  styleUrls: ['../cssMain.css']
})
export class LlBuildFormHolderComponent {


  @ViewChild('mainDiv_ll_build_form_holder') mainDiv: ElementRef;

  constructor(
    private LlScrollpaneService: LlScrollpaneService,
    private LlPermissionsService: LlPermissionsService,
    private LlInfoBuildService: LlInfoBuildService,
  ) { }

  bundle = {
    showPanel: false,
    mode: '',
    function: '',
    LlScrollpaneService: this.LlScrollpaneService,
    parentW: 0,
    parentH: 0,
    panelX: 0,
    panelY: 20,
    panelW: 0,
    panelH: 0,
   
  }


  ngAfterViewInit() {
    this.setVars();
  }

  setVars() {
    this.bundle.showPanel = false;

    this.bundle.function = this.mainDiv.nativeElement.parentElement.id;

    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    setTimeout(() => {
      this.bundle.panelW = this.bundle.parentW;
      this.bundle.panelH = this.bundle.parentH - this.bundle.panelY - 50;

      this.bundle.showPanel = true;
    });
  }



}
